<template>
    <div class="page">
        
            <!-- Header -->
            <v-layout class="first header">
                <div class="pbackground" :style="{ 'background-image': 'linear-gradient(0deg, rgba(9, 93, 169, 0.74), rgba(9, 93, 169, 0.74)), url(\'' + node.pathimg + '\')' }" >
                    <v-container>
                        <v-row justify="center" align="center" style="margin: 0 -12px;">
                            <v-col class="wrap" cols="12" sm="10">
                                <v-row style="margin: 0 -12px;">
                                    <v-col cols="12" sm="8" class="title">                                            
                                        <div>
                                            <!--<span class="headtitle">{{ $t(type) }}</span>-->
                                            <!--<span class="headtitle">{{ $t('testfield') }}</span>-->
                                            <span class="headtitle">{{ node.ar_name }}</span>
                                            <h3 v-if="$i18n.locale === 'de'">{{ node.title }}</h3>
                                            <h3 v-else>{{ node.title_en }}</h3>
                                        </div>
                                    </v-col>   
                                    <v-col cols="4" sm="4" class="titleright" style="display:flex;flex-direction: column-reverse;">                                            
                                        <div class="logocol">
                                            <FBicon :areaid="node.area"></FBicon>
                                        </div>
                                    </v-col>
                                </v-row>
                                </v-col>
                        </v-row>
                    </v-container>
                </div>

            </v-layout>                
            <v-layout class="breadcr">
                <v-container class="container py-0">                                            
                    <v-row justify="center" align="center">
                           <v-col cols="10" sm="10">
                            > <router-link :to="{ name: 'Suche'}">Übersicht</router-link> > Transferpass > {{ node.title }}
                           </v-col>
                      </v-row>
                </v-container>
            </v-layout>

            <!-- Description incl. PDF -->
            <v-layout class="content">
                <v-container class="">                                           
                    <v-row justify="center" align="center">
                        <v-col class="wrap" cols="12" md="10" xl="10">
                            <v-row>
                                <!-- Main column -->
                                <v-col cols="12" md="8">
                                    <!-- invisible pdfpass generator -->
                                    <pdfpass
                                        ref="html2Pdf"
                                        ></pdfpass>
                                    <div class="main" v-if="$i18n.locale === 'de'" v-html="node.description"></div>
                                    <div class="main" v-else v-html="node.description_en"></div>
                                    
                                    <div class="elementswrap"
                                        v-for="(element, key) in node.elements"
                                        :key="key" 
                                        cols="12" :md="element.cols"                           
                                        >               
                                        <h3 v-if="element.name">{{ element.name }}</h3>
                                        <h3 v-else>{{ element.elemname }}</h3>                                                     
                                        <div v-html="element.content"></div>                                                                   
                                    </div>
                                </v-col>
                                <!-- Side column -->
                                <v-col cols="12" md="4">
                                    <!--
                                    <qrcode-vue render-as="svg" :value="qrvalue" :size="qrsize" level="H" class="printqrcode"></qrcode-vue>
                                    -->
                                    <div class="modul" style="padding:10px 10px 20px;margin-bottom:30px;background-color:#f7f7f7">                                        
                                        <span class="topicheader">{{ $t('Contact') }}</span>
                                        <div class="body" v-if="node.responsible && node.responsible.length > 0">
                                            <div class="img" v-if="responsible">                                                                       
                                                <img :src="responsible.image + '&width=512'" alt="" class="contact"/>
                                            </div>
                                            <p class="name">{{ node.responsible[0].name }}</p>
                                            <div v-if="responsible" class="contact">
                                                <p v-html="'<span>Tel: </span>' + responsible.telephone"></p>
                                                <p v-html="'<span>E-Mail: </span>' + responsible.email"></p>
                                                <p v-if="responsible.office" v-html="'<span>Büro: </span>' + responsible.office"></p>
                                                <p v-if="responsible.comment" v-html="'<span>Büro: </span>' + responsible.comment"></p>
                                            </div>
                                        </div>
                                    </div>                                                                                                                                                                                                                   

                                    <div class="modul" style="padding:10px 10px 20px;margin-bottom:30px;background-color:#f7f7f7">                                        
                                        <span class="topicheader">{{ $t('Transferpass-Download') }}</span>
                                        <div class="body" v-if="node.responsible && node.responsible.length > 0">                                                
                                            <p>Hier können Sie einen Auszug der Transferpass-Inhalte von {{ node.responsible[0].name }} herunterladen.</p>

                                            <div class="mt-2"> 
                                            <v-tooltip max-width="340" left>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <a
                                                        @click="generateReport(node, responsible)"
                                                        >
                                                        <v-icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        size="34"
                                                        color="#0069b4"
                                                        class="px-0 py-0 mr-2 my-0 "
                                                        style="float:left"
                                                        >
                                                        mdi-file-pdf-box
                                                        </v-icon>
                                                        <span class="label">PDF Download</span>
                                                    </a>
                                                </template>
                                            <span>Get PDF from profile</span>
                                            </v-tooltip>                    
                                            </div>

                                        </div>
                                    </div>                                          
                                    <div class="modul gallerywrap" style="padding: 0 1px;" v-if="node.files && node.files.length > 0">
                                        <span
                                            v-for="(file, key) in node.files"
                                            :key="key + 1"
                                            >
                                            <v-img
                                                v-if="key < 5"
                                                max-height="120"
                                                max-width="200"
                                                :src="$config.imagepath + file.filename"
                                                @click="index = key"
                                                :class="{previmg: true, first: (key + 1) % 2 !== 0}"
                                            >
                                            </v-img>
                                        </span>
                                        <div class="body">                                                
                                            <div class="gallery">
                                                <vue-gallery-slideshow 
                                                    :images="images" 
                                                    :index="index" 
                                                    @close="index = null"                                    
                                                ></vue-gallery-slideshow>
                                            </div>
                                        </div>
                                    </div>

                                    <!--
                                    <div class="modul gallerywrap" v-if="node.files && node.files.length > 0">
                                        <div class="body">                                                
                                            <div class="gallery">                                                    
                                                <vue-gallery-slideshow 
                                                    :images="images" 
                                                    :index="index" 
                                                    @close="index = null"                                    
                                                ></vue-gallery-slideshow>                                                                                
                                            </div>                                                
                                        </div>            
                                    </div>
                                    -->
                                                                                                                    
                                    <div class="modul" v-if="usecases && usecases.length > 0">                                            
                                        <span class="topicheader">{{ $t('usecases_in_testfield')}}</span>                                    

                                        <v-btn
                                            class="ma-2 usecase-btn"
                                            v-for="(usecase, key) in usecases"
                                            :key="key"
                                            depressed                                                                                                                           
                                            :to="'/'+$home+'p/usecase/'+usecase.id" 
                                        >       
                                            <v-icon left>
                                                mdi-cogs
                                            </v-icon>                                                                     
                                            {{ usecase.name }}                                        
                                        </v-btn>                

                                    </div>

                                    <div class="modul" v-if="node.devices && node.devices.length > 0">             
                                        <span class="topicheader">Ausstattung</span> 

                                        <v-btn
                                            class="ma-2 tools-btn"                                                                                                
                                            depressed                                                                                                                           
                                            :to="'/'+$home+'p/devices/'+node.id" 
                                            v-if="node.devices"
                                        >       
                                            <v-icon left>
                                                mdi-tools
                                            </v-icon>                                                                     
                                            Hardware und Software ({{ node.devices.length }})
                                        </v-btn>                

                                    </div>

                                    <!--
                                    <v-btn
                                        class="ma-0"                                                                                        
                                        depressed                                            
                                        color="#90ee90"
                                        :to="'/suche'" 
                                        style="margin-bottom:20px !important;"
                                    >
                                    <v-icon
                                        right
                                        dark
                                        style="margin-right:10px;margin-left:0"                                            
                                    >
                                        mdi-download-box-outline
                                    </v-icon>                                        
                                        Transfersteckbrief
                                    </v-btn>
                                    -->

                                    <div class="modul links" v-if="node.links && node.links.length > 0">
                                    <!--<span class="topicheader">{{ $t('Readmore') }}</span>-->
                                        <div
                                            v-for="(link, key) in node.links"
                                            :key="key"                                        
                                            >
                                            <v-btn
                                                class="ma-2 url-btn"                                                                         
                                                depressed                                            
                                                color="#ddd"
                                                target="_blank"
                                                :href="link.url"
                                                max-height="100"
                                            >
                                                <v-icon left>
                                                    mdi-link-variant
                                                </v-icon>                                                                                                             
                                                {{ link.name.replace(/(.{30})..+/, "$1…") }}
                                            </v-btn>                
                                            <!--
                                            <v-html class="ml-11 url-desc">
                                            </v-html>
                                            -->
                                        </div>
                                    </div>                                       

                                    <div class="modul" v-if="node.tags && node.tags.length > 0">
                                        <span class="topicheader">{{ $t('Topics') }}</span>
                                        <v-btn
                                            class="ma-2"
                                            v-for="(tag, key) in node.tags"
                                            :key="key"
                                            depressed                                            
                                            color="#ddd"
                                            :to="'/'+$home+'search?t='+tag.name" 
                                        >                                        
                                            {{ $t(tag.name) }}                                        
                                        </v-btn>                
                                    </div>                 

                                </v-col>
                                </v-row>                                                                          
                            <v-row class="imgsection" align="end">
                            </v-row>                            

                        </v-col>
                    </v-row>
                </v-container>
            </v-layout>

            <!-- Offers -->
            <v-layout class="iblue" v-if="usecases && usecases.length > 0">
                <v-container>
                      <v-row justify="center" align="center">
                          <v-col class="wrap" cols="10" sm="10">
                              <h4>{{ $t('Offers by the testfield') }}</h4>
                              <v-row >
                                  <FieldUsecases :usecases="usecases"></FieldUsecases>
                              </v-row>
                          </v-col>
                      </v-row>
                </v-container>
            </v-layout>

            <!-- Elements
            <v-layout>
                <v-container>
                    <v-row justify="center" align="center">
                        <v-col class="wrap" cols="12" md="10">
                            <v-row>
                            <v-col class="servicewrap"
                                v-for="(element, key) in node.elements"
                                :key="key" 
                                cols="12" :md="element.cols"                           
                                >                                                                    
                                <h4>{{ element.name }}|{{element.cols}}</h4>
                                <div v-html="element.content"></div>                                                                   
                            </v-col>               
                            </v-row>                 
                        </v-col>
                    </v-row>
                </v-container>
            </v-layout>
            -->

            <v-layout class="equipment" v-if="node.devices && node.devices.length > 0">
                <v-container>
                    <!-- Equipment cards -->
                    <v-row justify="center" align="center">
                        <v-col class="wrap" cols="10" sm="10">                                        
                        <h4>Ausstattung der Forschungsgruppe</h4>
                        <v-carousel
                            height="300"
                            hide-delimiter-background
                            delimiter-icon="mdi-minus"                        
                            hide-delimiters
                            > 
                            <template v-for="(dev, index) in node.devices"> 
                            <v-carousel-item v-if="(index + 1) % columns === 1 || columns === 1" 
                                :key="index"
                            > 
                                <v-row class="flex-nowrap" style="height:100%"> 
                                <template v-for="(n,i) in columns"> 
                                    <template v-if="(+index + i) < node.devices.length"> 
                                    <v-col :key="i"> 
                                        <v-sheet v-if="(+index + i) < node.devices.length"                                                 
                                            height="100%"
                                            color="transparent"                                            
                                        >
                                        <v-row class="fill-height"
                                            align="center"
                                            justify="center"
                                        >
                                            <div class="item">
                                                <router-link
                                                    :to="'/'+$home+'p/device/'+node.devices[+index + i].dev_id"
                                                    >
                                                    <img :src="node.devices[+index + i].paththumb" alt="xx" />
                                                    <div class="desc">                                        
                                                        <div class="category">{{ node.devices[+index + i].category }}</div>
                                                        <div>{{ node.devices[+index + i].name }}</div>
                                                        <div
                                                            v-if="node.devices[+index + i].manufacturer"
                                                            >
                                                            Hersteller: {{ node.devices[+index + i].manufacturer }}
                                                        </div>                                                        
                                                        <div
                                                            v-if="node.devices[+index + i].purchasedate"
                                                            >
                                                            Anschaffung: {{ node.devices[+index + i].purchasedate | dateParse('YYYY-MM-DD') | dateFormat('YYYY') }}
                                                        </div>
                                                    </div>
                                                </router-link>
                                            </div>
                                        </v-row>
                                        </v-sheet>
                                    </v-col> 
                                    </template> 
                                </template> 
                                </v-row> 
                            </v-carousel-item> 
                            </template> 
                        </v-carousel>  

                        <!--
                        <v-slide-group                            
                            class="py-4 px-0 mb-2"
                            show-arrows
                            >
                            <v-slide-item
                                v-for="(dev, key) in node.devices"
                                :key="key"
                            >
                                <v-card
                                color="lightgreen"
                                class="ma-1"
                                height="220"
                                width="220px"               
                                :to="'/'+$home+'p/device/'+dev.dev_id"                 
                                >
                                <v-row
                                    class="fill-height ma-0 pa-0"
                                    align="center"
                                    justify="center"
                                >                                
                                <v-img
                                    :src="dev.pathimg"                                    
                                    class="ma-1"
                                    height="140px"
                                    >
                                </v-img>
                                {{ dev.name }}
                                </v-row>
                                </v-card>
                            </v-slide-item>
                        </v-slide-group>
                        -->

                        <div class="modul" v-if="node.devices && node.devices.length > 0">                                     
                            <div class="body">
                            <router-link
                                class="ma-0 pa-0 link"                                                                                                
                                depressed                                            
                                color="#ddd"                                                                                            
                                :to="'/'+$home+'p/devices/'+node.id"
                                v-if="node.devices"
                            >                                        
                                {{ $t('Overview Hardware and Software') }} ({{ node.devices.length }})
                            </router-link>    
                            </div>            
                        </div>
                           
                        </v-col>
                    </v-row>        

                </v-container>
            </v-layout>

            <!-- Responsible / Contact -->
            <!--
            <v-layout class="iblue" v-if="responsible">
                <v-container>
                      <v-row justify="center" align="center">
                          <v-col class="wrap" cols="9" sm="9">
                                <Contact :contacts="responsible"></Contact>
                          </v-col>
                      </v-row>
                </v-container>
            </v-layout>
            -->

            <v-layout class="iwhite">
                <v-container>
                      <v-row justify="center" align="center">
                          <v-col class="wrap" cols="10" sm="10">
                              <div v-if="node.id">
                              <h4>Weitere Transferpass-Angebote</h4>
                              <Testfields :current="node.id"></Testfields>                              
                              </div>
                          </v-col>
                      </v-row>
                </v-container>
            </v-layout>

    </div>
</template>

<script>

import FieldUsecases from './FieldUsecases';
import Testfields from './Testfields';
// import Contact from '../elements/Contact';
import FBicon from '../elements/FBicon';
import VueGallerySlideshow from 'vue-gallery-slideshow';
import pdfpass from "../pdfpass.vue";
// import QrcodeVue from 'qrcode.vue';

    export default {
        name: 'Page',
        data() {
            return {
                qrvalue: 'https://example.com',
                qrsize: 300,
                type: 'testfield',
                usecases: null,                
                images: [],
                responsible: null,
                iconpath: null,
                links: [
                    {
                        url: 'https://www.th-wildau.de/wildauer-maschinen-werke/testfeld/',
                        name: 'WMW Wildau Maschinenwerke',
                        desc: 'WMW Wildauer Maschinenwerke',
                        tfid: 2
                    },
                    {
                        url: 'https://www.th-wildau.de/wildauer-maschinen-werke/',
                        name: 'WMW Lernplattform',
                        desc: 'xxxZxxx',
                        tfid: 2
                    },
                    {
                        url: 'https://www.th-wildau.de/wildauer-maschinen-werke/testfeld/',
                        name: 'NLP in der Kundenbetreuung',
                        desc: 'WMW Wildauer Maschinenwerke',
                        tfid: 3
                    },
                    {
                        url: 'https://www.th-wildau.de/wildauer-maschinen-werke/',
                        name: 'NLP als Prozess',
                        desc: 'xxxZxxx',
                        tfid: 3
                    },
                    {
                        url: 'https://www.th-wildau.de/wildauer-maschinen-werke/testfeld/',
                        name: 'Robotikanwendung im Smart Home',
                        desc: 'WMW Wildauer Maschinenwerke',
                        tfid: 4
                    },
                    {
                        url: 'https://www.th-wildau.de/wildauer-maschinen-werke/',
                        name: 'Anwendungsfälle Social Robotics',
                        desc: 'xxxZxxx',
                        tfid: 4
                    }                                        
                ],
                index: null
            };
        },
        props: {
            node: {
                type: Object
            }
        },
        components: {
          // QrcodeVue,
          FieldUsecases,
          Testfields,
          // Contact,
          FBicon,
          VueGallerySlideshow,
          pdfpass
        },
        methods: {  
            getUser () {
                const self = this                
                if(this.node.responsible && this.node.responsible.length > 0) {
                    this.axios.get( this.$config.host + '/accountinfo/' + this.node.responsible[0].ldap_id )
                    .then(result => {                  
                        if(result.data && result.data.length > 0) {
                        self.responsible = result.data[0]
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
                }
            },
            generateReport (pass, responsible) {
                console.log('PASS:');
                console.log(pass);
                this.$refs.html2Pdf.generatePdfProfile(pass, responsible)
            },    
            getUsecasesByTestfieldId() {
                let self = this;
                this.axios.get( this.$config.host+"/usecases/testfield/" + this.node.id ).then(function (response) {                                    
                  response.data.sort((a,b) => (b.generated > a.generated) ? 1 : ((a.generated > b.generated) ? -1 : 0));                                    
                  self.usecases = response.data;
                });
            },
            setImages() {
                // console.log('setImages()');
                if(this.node.files) {
                    let self = this;
                    this.node.files.forEach(function (file) {                        
                        self.images.push(self.$config.imagepath + file.filename)
                    });
                    // console.log(self.images);      
                }
            },
            setIcons() {
                switch (this.node.id) {
                    case 2:
                        this.iconpath = 'Testbed_AutonomesFahren_Icon_klein.svg';
                        break;
                    case 3:
                        this.iconpath = 'Testbed_NLP_Icon_klein.svg';
                        break;
                    case 4:
                        this.iconpath = 'Testbed_SocialRobotics_Icon_klein.svg';
                        break;                
                    default:
                        break;
                }                                                            
            }
        },
        created() {

        },
        computed: {
            columns() {
                if (this.$vuetify.breakpoint.xl) {                    
                    return 5;
                }
                if (this.$vuetify.breakpoint.lg) {                    
                    return 4;
                }
                if (this.$vuetify.breakpoint.md) {                    
                    return 3;
                }
                if (this.$vuetify.breakpoint.sm) {                    
                    return 2;
                }                
                return 1;
            }
        },
        mounted() {
            // console.log("PageContent: node wert (testfield) on mounted?");
            // console.log(this.node);            
            this.setImages();
        },
        watch: {
            node: function (values) {
                this.node = values;
                this.getUsecasesByTestfieldId(); 
                this.setImages();
                this.setIcons();          
                this.getUser();     
            },
            responsible: function (value) {
                if(value && value.telephone == undefined) {
                    value.telephone = "";
                    this.responsible = value;
                }
            },
            usecases: function (values) {
                this.usecases = values;
            }            
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.equipment {
    background-color: #f4f4f4;
}
.equipment .v-sheet > .row {
    margin:0;
}
.equipment .item {
    display: block;
    padding:10px;
    border:1px solid #ddd;
}
.equipment .item .desc {
    height:6rem;
    padding:6px;
    font-size: 0.88rem;
}
.equipment .item .desc .category {
    font-style: italic;
}
.equipment .item a {
    text-decoration: none;
    color:rgba(0, 0, 0, 0.87);
}
.equipment .item img {    
    max-width:220px;    
    width:200px;
}
</style>
